// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBcdpj30k4EP16pz-1vIzhvyCbURDimM4A",
  authDomain: "lifemap-418201.firebaseapp.com",
  projectId: "lifemap-418201",
  storageBucket: "lifemap-418201.appspot.com",
  messagingSenderId: "96859907235",
  appId: "1:96859907235:web:4f7c26a13821def679cb16",
  measurementId: "G-P375K2JQNC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
isSupported().then((supported) => {
  if (supported) getAnalytics(app);
});
export { app };
export const db = getFirestore(app);
